// extracted by mini-css-extract-plugin
export default {"fullWidth":"Bn-z","image":"Cn-z","lazyLoadPicture":"Dn-z","lazyLoadSpinner":"En-z","lazyLoadSpin":"Fn-z","lazyLoadImage":"Gn-z","hasStyledAspectRatio":"Hn-z"};